import store from '@/store';

const RiskResources = [
	{
		name: 'RiskResourcesHome',
		path: '/risk-resources/',
		component: () =>
			import(/* webpackChunkName: "RiskResources" */ '@/pages/RiskResources/Home.vue'),
		meta: {
			title: 'Risk Resources',
			auth: true,
		},
	},
	{
		name: 'RiskResourcesPages',
		path: '/risk-resources/*',
		component: () =>
			import(/* webpackChunkName: "RiskResources" */ '@/pages/RiskResources/Page.vue'),
		meta: {
			title: 'Risk Resources',
			auth: true,
		},
		beforeEnter: async (to, from, next) => {
			await store.dispatch('RiskResources/clearData');
			next();
		},
	},
];

export default RiskResources;
